import(/* webpackMode: "eager", webpackExports: ["MarketingShell"] */ "/vercel/path0/src/components/piai/shell/MarketingShell.tsx");
